import { TeamMember } from '@demind-inc/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { TeamShareSettingsUpdateReq, teamApi } from '../api';
import {
  TEAM_DAY_QUERY_KEY,
  TEAM_DETAIL_QUERY_KEY,
  TEAM_LIST_QUERY_KEY,
  TEAM_TASKS_QUERY_KEY,
} from '../queries';

interface UpdateTeamShareSettingsParams {
  teamId: string;
  teamShareSettingsUpdateReq: TeamShareSettingsUpdateReq;
}

export const useUpdateTeamShareSettings = () => {
  const queryClient = useQueryClient();

  const updateTeamShareSettingsMutation = useMutation({
    mutationFn: ({ teamId, teamShareSettingsUpdateReq }: UpdateTeamShareSettingsParams) => {
      return teamApi
        .updateTeamShareSettings(teamId, teamShareSettingsUpdateReq)
        .then(({ data }) => data.membership as TeamMember);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: TEAM_LIST_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: TEAM_DETAIL_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: TEAM_DAY_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: TEAM_TASKS_QUERY_KEY });
    },
  });

  return {
    updateTeamShareSettings: updateTeamShareSettingsMutation.mutateAsync,
    isUpdatingTeamShareSettings: updateTeamShareSettingsMutation.isPending,
    ...updateTeamShareSettingsMutation,
  };
};
